import React, { useEffect, useRef, useState } from 'react';

// Reveal: lightweight scroll reveal using IntersectionObserver
// Props: as, children, delay (ms), y (px), duration (ms), scaleFrom (number)
const Reveal = ({
  as: Tag = 'div',
  children,
  className = '',
  delay = 0,
  y = 16,
  duration = 300,
  scaleFrom = 1,
}) => {
  const ref = useRef(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;

    const prefersReduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (prefersReduced) {
      setVisible(true);
      return;
    }

    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setTimeout(() => setVisible(true), delay);
            io.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12 }
    );

    io.observe(el);
    return () => io.disconnect();
  }, [delay]);

  const style = {
    transition: `opacity ${duration}ms cubic-bezier(0.22, 1, 0.36, 1), transform ${duration}ms cubic-bezier(0.22, 1, 0.36, 1)`,
    transform: visible ? 'translateY(0) scale(1)' : `translateY(${y}px) scale(${scaleFrom})`,
    opacity: visible ? 1 : 0,
  };

  return (
    <Tag ref={ref} className={className} style={style}>
      {children}
    </Tag>
  );
};

export default Reveal;


